export default "__VITE_ASSET__DPIOAlBW__"